import { footerContacts, navbarMainTabs } from 'src/lib'
import FooterSection from './FooterSection'
import { Logo, Right } from 'src/assets'
import { Button } from 'src/components'
import { Link } from 'react-router-dom'
import { t } from 'i18next'

const DesktopFooter = () => {
  return (
    <div className='w-full h-full pt-[60px] bg-center bg-no-repeat bg-cover bg-forest2 flex-column'>
      <div className='w-full h-2/3 box-border  flex-column justify-center items-center text-center gap-[30px]'>
        <div className='text-white w-1/2 text-[80px] text-bold '>
          {t('footer.title')}
        </div>
        <div className='text-white w-1/2 text-[20px]'>
          {t('footer.subtitle')}
        </div>
        <Button size='m' icon={<Right />}>
          {t('global.get.started')}
        </Button>
      </div>
      <div className='w-full h-1/3 backdrop-blur-[3px] relative flex-column'>
        <div className='flex w-full h-full px-[70px] justify-between items-center'>
          <div className='flex gap-[20px]'>
            <FooterSection
              {...{
                className: 'w-[200px]',
                title: t('global.contact'),
                options: footerContacts,
              }}
            />
            <FooterSection
              {...{
                className: 'w-[200px]',
                title: t('global.explore'),
                options: navbarMainTabs.map(({ link, name }) => ({
                  label: t(name),
                  to: link,
                })),
              }}
            />
          </div>
          <Logo className='min-w-[150px] min-h-[150px]' />
        </div>
        <div className='w-full h-[80px] px-[70px] justify-between flex gap-[10px]'>
          <div className='h-full flex-center text-white'>
            All rights reserved Travel © 2024 Cookies policy Terms & Conditions
          </div>
          <div className='flex gap-[10px] flex-center'>
            {footerContacts.map(({ to, icon: Icon }) => (
              <Link key={to} to={to}>
                <Icon />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopFooter
